import React from 'react'
import { Link } from 'react-router-dom'
import { LogoStyle } from '../../../styles'
import { RM } from '../../../components'

export default () => (
  <div className={`logo ${LogoStyle}`} >
    <Link to="/">
      <RM width={38} height={15} /> 
      <span className="logo--label">Brand Center</span>
    </Link>
  </div>
)


// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/Logo.js